function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { stripUnit } from 'polished';
import { type } from '../../styles/theme';
import mediaMin, { breakpointsEm } from '../../styles/breakpoints';
const StyledFontSize = styled.span.withConfig({
  displayName: "FontSize__StyledFontSize",
  componentId: "sc-1b22blh-0"
})(["", ";"], x => {
  const unitlessScale = scale => stripUnit(type.scale[scale]);

  if (x.size && typeof x.size === 'string') {
    return css(["font-size:", ";"], x.size);
  } else if (x.scale && x.useRem) {
    return css(["font-size:", ";", "{font-size:", ";}", "{font-size:", ";}"], type.scale[x.scale + 1], mediaMin.sm, `calc(
              (${type.scale[x.scale + 1]}) +
              (${unitlessScale(x.scale)} - ${unitlessScale(x.scale + 1)}) *
              (100vw - ${stripUnit(breakpointsEm.sm)}rem) /
              (${stripUnit(breakpointsEm.lg)} - ${stripUnit(breakpointsEm.sm)})
            )`, mediaMin.lg, type.scale[x.scale]);
  } else if (x.scale) {
    return css(["font-size:", ";", "{font-size:", ";}", "{font-size:", ";};"], stripUnit(type.scale[x.scale + 1]) + 'em', mediaMin.sm, `calc(
              ${stripUnit(type.scale[x.scale + 1])}em +
              (${unitlessScale(x.scale)} - ${unitlessScale(x.scale + 1)}) *
              (100vw - ${breakpointsEm.sm}) /
              (${stripUnit(breakpointsEm.lg)} - ${stripUnit(breakpointsEm.sm)})
            )`, mediaMin.lg, stripUnit(type.scale[x.scale]) + 'em');
  }
}).withComponent((_ref) => {
  let {
    scale,
    size
  } = _ref,
      domProps = _objectWithoutProperties(_ref, ["scale", "size"]);

  return /*#__PURE__*/React.createElement("span", domProps);
});
export const FontSize = (_ref2) => {
  let {
    children,
    scale = 6,
    size
  } = _ref2,
      props = _objectWithoutProperties(_ref2, ["children", "scale", "size"]);

  return /*#__PURE__*/React.createElement(StyledFontSize, _extends({
    scale: scale,
    size: size
  }, props), children);
};
export const Larger = (_ref3) => {
  let {
    children
  } = _ref3,
      props = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React.createElement(FontSize, _extends({
    scale: 3
  }, props), children);
};
export const Large = (_ref4) => {
  let {
    children
  } = _ref4,
      props = _objectWithoutProperties(_ref4, ["children"]);

  return /*#__PURE__*/React.createElement(FontSize, _extends({
    scale: 4
  }, props), children);
};
export const Small = (_ref5) => {
  let {
    children
  } = _ref5,
      props = _objectWithoutProperties(_ref5, ["children"]);

  return /*#__PURE__*/React.createElement(FontSize, _extends({
    scale: 6
  }, props), children);
};
export const Smaller = (_ref6) => {
  let {
    children
  } = _ref6,
      props = _objectWithoutProperties(_ref6, ["children"]);

  return /*#__PURE__*/React.createElement(FontSize, _extends({
    scale: 7
  }, props), children);
};